import axios from 'axios'
import apiPath from 'apiPath'
import moment from 'components/momentWithZone'

let loadFieldPrograms2 = (voyage) => {
	return new Promise((resolve, reject) => {
		axios
			.get(apiPath + '/itemsnew', {
				params: { voyageId: voyage, verbose: true },
			})
			.then((response) => {
				const data = response.data.map((program) => {
					program.trip_types = [] //TODO: Trip Types = where does this info come from? Type are IsLeanIn, Is Strenuous, IsFastPaced but are notated by a series of numbers

					return program
				})

				let cruiseId = data.length > 0 ? data[0].CruiseId : null
				sessionStorage.setItem('fieldProgramsForVoyage', cruiseId)
				sessionStorage.setItem('fieldPrograms', JSON.stringify(data))
				sessionStorage.setItem('fieldProgramsUpdated', moment().unix())
				resolve()
			})
			.catch(reject)
	})
}

module.exports = loadFieldPrograms2



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/loadFieldPrograms2.js